import { getLowestFraction } from './index';
export var getFractionDose = function (quantity) {
    var integerQuantityPart = Math.floor(Number(quantity));
    var decimalQuantityPart = Number(quantity) - integerQuantityPart;
    var fractionalValue = getLowestFraction(decimalQuantityPart);
    return "".concat(integerQuantityPart !== 0 ? integerQuantityPart + ' ' : '').concat(decimalQuantityPart > 0 ? fractionalValue : '');
};
